import { epicRequest, reducersMerge, reduxFetchCreator, serverResponse } from 'app'

import type { InstitutionSchema, SearchFilterSchema } from 'search'

const getInitialState = () =>
  serverResponse<InstitutionSchema.Institution[]>({
    key: '',
    data: [],
  })

const list = reduxFetchCreator<'searchInstitutions', SearchFilterSchema, ReturnType<typeof getInitialState>>(
  'searchInstitutions',
  getInitialState(),
  {
    fulfilled: (state, action) => {
      if (action.payload.originalAction?.payload.key === state.originalAction?.payload.key) {
        action.payload.data = [...state.data, ...action.payload.data]
      }

      return action.payload
    },
  },
)

const searchInstitutionsEpic = epicRequest({
  actionType: list.actions.searchInstitutions.type,
  debounce: 700,
  errorAction: list.actions.searchInstitutionsError,
  fulfilledAction: list.actions.searchInstitutionsFulfilled,
  request: ({ payload }) => ({
    body: { ...payload, type: 'institutions' },
    method: 'post',
    url: 'search',
  }),
  untilTypes: list.actions.searchInstitutionsCancel.type,
})

const toggleFollow = reduxFetchCreator<
  'searchInstitutionsToggleFollow',
  { id: string; follow: boolean },
  ReturnType<typeof getInitialState>
>('searchInstitutionsToggleFollow', getInitialState(), {
  fulfilled: (state, action) => {
    state.data = state.data.map((oldInstitution) => {
      const newInstitution = action.payload.data.find(({ id }) => id === oldInstitution.id)
      return newInstitution || oldInstitution
    })
  },
})

const searchInstitutionsToggleFollowEpic = epicRequest({
  actionType: toggleFollow.actions.searchInstitutionsToggleFollow.type,
  debounce: 700,
  errorAction: toggleFollow.actions.searchInstitutionsToggleFollowError,
  fulfilledAction: toggleFollow.actions.searchInstitutionsToggleFollowFulfilled,
  request: ({ payload }) => ({
    body: { ...payload, type: 'institutions' },
    method: 'post',
    url: 'search/follow',
  }),
  untilTypes: toggleFollow.actions.searchInstitutionsToggleFollowCancel.type,
})

export const actions = {
  ...list.actions,
  ...toggleFollow.actions,
}

export const epics = [searchInstitutionsEpic, searchInstitutionsToggleFollowEpic]

export const reducer = reducersMerge(list.reducer, toggleFollow.reducer)
